import { Wrench } from "lucide-react";
import { MetricWidget } from "@/components/custom/widgets/metric-widget";
import { useGetTools } from "../../../tools/api/hooks";

export function ToolsMetric() {
  const { data: tools } = useGetTools();

  return (
    <MetricWidget
      href="/orgs/$organizationId/projects/$projectId/tools"
      icon={Wrench}
      title="Tools"
      value={tools?.items.length ?? 0}
    />
  );
}
